module.exports = __webpack_public_path__ + "static/media/sf-test-1.5607e654.mp3";